const initialState = {
    cards: [], isLoading: true, updateResponse: "", stripePK: null, buttonDisable: false
};

export const paymentReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'PROFILE_GET_REQUEST':
            return {
                ...state,
                isLoading: action.payload.isLoading,
            }
        case 'PROFILE_GET_RESPONSE':

            return {
                ...state,
                isLoading: action.payload.isLoading,
                userInfo: action.payload.userDetail
            }

        case 'CUSTOMER_SAVE_CARD_REQUEST':
            return {
                ...state,
                isLoading: action.payload.isLoading
            }

        case 'CUSTOMER_SAVE_CARD_RESPONSE':
            return {
                ...state,
                isLoading: action.payload.isLoading
            }

        case 'CUSTOMER_CREDIT_CARD_REQUEST':
            return {
                ...state,
                isLoading: action.payload.isLoading,
            }

        case 'CUSTOMER_CREDIT_CARD_RESPONSE':
            return {
                ...state,
                cards: action.payload.cards,
                stripePK: action.payload.stripePK,
                isLoading: action.payload.isLoading,
            }

        case 'SAVEBUTTON_DISABLED':
            return {
                ...state,
                buttonDisable: action.payload.buttonDisable
            }

        case 'SAVEBUTTON_ACTIVE':
            return {
                ...state,
                buttonDisable: action.payload.buttonDisable
            }       

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/PaymentReducer.js